import { createGlobalStyle } from "styled-components";

export const V2 = {
  controlHeight: "44px",
  controlRadius: "10px",
  surfaceRadius: "14px",
  dialogRadius: "16px",
  spacing: "16px",
  ink: "#17243B",
  muted: "#617087",
  accent: "#2B5C8A",
  accentSoft: "#E8F0F8",
  canvas: "#F5F6FA",
  border: "#E3E7EF",
  sidebar: "#151D30",
  shadow: "0 2px 4px rgba(24,35,57,.025), 0 8px 28px rgba(24,35,57,.045)",
};

// Shared motion also covers overlays portalled outside the workspace.
export const DesignV2Style = createGlobalStyle`
  :root {
    --v2-accent: #2b5c8a;
    --v2-ease: cubic-bezier(.22, 1, .36, 1);
  }
  @keyframes v2-enter {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes v2-dialog-enter {
    from { opacity: 0; transform: translateY(18px) scale(.975); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
  @keyframes v2-backdrop-enter { from { opacity: 0; } to { opacity: 1; } }
  @keyframes v2-panel-enter {
    from { opacity: 0; transform: translateX(40px); }
    to { opacity: 1; transform: translateX(0); }
  }
  [data-page-content] { animation: v2-enter 380ms var(--v2-ease) both; }
  [data-dialog-surface='desktop'] { animation: v2-dialog-enter 340ms var(--v2-ease) both; }
  [data-dialog-surface='desktop'][data-dialog-layout-mode='side'] {
    animation: v2-panel-enter 320ms var(--v2-ease) both;
  }
  [data-dialog-backdrop='desktop'] { animation: v2-backdrop-enter 220ms ease both; }
  [data-profile-menu] { animation: v2-dialog-enter 240ms var(--v2-ease) both; transform-origin: top right; }
  [data-typo='caption'] { opacity: .88; }
  button, [role='button'], [role='tab'], [role='combobox'] { -webkit-tap-highlight-color: transparent; }
  button:focus-visible, [role='button']:focus-visible, [role='tab']:focus-visible,
  [role='combobox']:focus-visible, a:focus-visible {
    outline: 3px solid #8c88f3; outline-offset: 3px;
  }
  input:focus-visible, textarea:focus-visible { outline-color: var(--v2-accent); }
  input, select, textarea { accent-color: var(--v2-accent); }
  input::placeholder, textarea::placeholder { font-style: normal !important; }
  body:has([data-workspace]) > .cp-cookie-settings,
  body:has([data-auth-surface]) > .cp-cookie-settings,
  body:has([role='dialog']) > .cp-cookie-settings { visibility: hidden; }
  ::-webkit-scrollbar { width: 5px; height: 5px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb { background: #c5cad6; border-radius: 99px; }
  @media (max-width: 768px) {
    input:not([type='checkbox']):not([type='range']), textarea, select { font-size: 16px; }
    [data-workspace='company'] ~ .cp-cookie-settings,
    body:has([data-workspace]) > .cp-cookie-settings {
      bottom: calc(90px + env(safe-area-inset-bottom, 0px));
    }
  }
  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: .01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: .01ms !important;
      scroll-behavior: auto !important;
    }
  }
`;
